import {Component, HostListener, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {Hotel} from '../../core/viewModel/hotel';
import {Planos} from '../../core/viewModel/planos.model';
import {ItemProposta, Proposta, ValoresTitulosDetalhado} from '../../core/viewModel/proposta.model';
import {AppComponent} from '../../app.component';
import {CategoriaPlanoService} from '../../core/services/categoria_plano.service';
import {HotelService} from '../../core/services/hotel.service';
import {DestinoService} from '../../core/services/destino.service';

@Component({
    selector: 'app-detalhes-hotel',
    templateUrl: './detalhes-hotel.component.html',
    styleUrls: ['./detalhes-hotel.component.sass']
})
export class DetalhesHotelComponent implements OnInit {

    public detalheHotel: any;
    public comodidades = [];
    public grupoComodidades = [];
    public hasTop = false;
    public showComodidade = [];
    public showBtnComodidade = false;
    public primeiroDestino: any;
    public queryParamData: any;
    public images: any[];
    public filteredBrands: any[];
    public brand: any;
    public isOpenMap: boolean;
    public urlMap: string;
    public innerWidth: any;
    public tipoQuarto: string;
    public plano: Planos;
    public proposta: Proposta;
    public planoSelecionado: any;
    isMobile = false;
    panelHeight;
    panelWidth;

    constructor(
        public hotelService: HotelService,
        public destinoService: DestinoService,
        private route: ActivatedRoute,
        private router: Router,
        public sanitizer: DomSanitizer,
        private categoriaPlanoRepository: CategoriaPlanoService,
        private appComponent: AppComponent
    ) {
        this.queryParamData = route.snapshot.params.data;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.handleMobile();
    }

    async ngOnInit() {
        localStorage.removeItem('mtl.proposta');
        this.panelHeight = '455';
        this.panelWidth = '100%';
        this.images = [];
        this.loadPrimeiroDestino();
        this.handleMobile();
        if (this.queryParamData) {
            await this.loadDetalheHotel();
            await this.getPlanos();
        }
    }

    getUrlMap(detalheHotel) {
        this.urlMap = 'https://www.google.com/maps/embed/v1/place?q=' +
            detalheHotel.latitude + ',' + detalheHotel.longitude +
            '&key=AIzaSyDk9qZYzd3TM6ckrmPPlkDgYkQLfPplPJo';
    }

    async buscarPorCodContrato(codContrato: number) {
        if (
            codContrato === 1010 ||
            codContrato === 1001 ||
            codContrato === 1002 ||
            codContrato === 1003 ||
            codContrato === 1011 ||
            codContrato === 1012 ||
            codContrato === 2020 ||
            codContrato === 2001 ||
            codContrato === 2002 ||
            codContrato === 2003 ||
            codContrato === 2021 ||
            codContrato === 2022 ||
            codContrato === 2023 ||
            codContrato === 3030 ||
            codContrato === 3031 ||
            codContrato === 3032 ||
            codContrato === 3001 ||
            codContrato === 3002 ||
            codContrato === 3003
        ) {
            return this.hotelService.buscaPorCodContratoEstatico(codContrato);
        }
        return await this.hotelService.buscaPorCodContrato(codContrato);
    }

    async loadDetalheHotel() {
        const params = this.queryParamData.split('_');
        const resultData = await this.buscarPorCodContrato(+params[0]);
        this.detalheHotel = this.setAltTitleHoteisProximos(resultData.data);
        this.loadComodidades();
        this.getFotos();
    }

    loadComodidades() {
        if (this.detalheHotel && this.detalheHotel.comodidades.length > 0) {
            this.grupoComodidades = this.detalheHotel.comodidades;
            this.grupoComodidades.map(obj => {
                if (obj.nome === 'Comodidades') {
                    obj.nome = 'Outros';
                }
                if (obj.comodidades.length > 0) {
                    obj.comodidades.map(com => {
                        com.icon = 'fas fa-plus-circle';
                    });
                }
            });
        }
    }

    clickShowComodidade(grupoComodidade: any) {
        this.showComodidade.push(grupoComodidade);
    }

    clickHideComodidade(grupoComodidade: any) {
        let data = this.showComodidade;
        data = data.filter(obj => obj !== grupoComodidade);
        this.showComodidade = data;
    }

    showComodidades(grupoComodidade: any) {
        let data = [];
        data = this.showComodidade.filter( obj => obj === grupoComodidade);
        return data.length > 0;
    }

    pushGrupoComodidade(comodidade: any) {
        comodidade.forEach(c => this.pushComodidade(c));
    }

    pushComodidade(comodidade: any) {
        this.comodidades.push(comodidade);
    }

    getFotos() {
        this.images = [];
        if (this.detalheHotel.fotos) {
            this.detalheHotel.fotos.forEach((e, index) => {
                const alt = `${this.detalheHotel.alt} - Foto  ${index + 1}`;
                const title = `Imagem ${index + 1} - ${this.detalheHotel.alt}`;
                this.images.push({ source: e });
            });
        }
    }

    async loadPrimeiroDestino() {
        this.setStorage();
        this.primeiroDestino = await this.destinoService.listaDestinos().destinos[0];
    }

    navegarParaDetalheHotel(item): void {
        const param = item.codContrato + '_' + item.slug;
        this.router.navigate(['/hoteis/hotel/', param]);
        this.queryParamData = param;
        this.loadPrimeiroDestino();
        if (this.queryParamData) {
            this.loadDetalheHotel();
        }
    }

    public irParaDestino(slug) {
        this.setStorage();
        this.router.navigate(['/destinos', slug]);
    }

    public hoteisDestinos(id) {
        this.setStorage();
        this.router.navigate(['/busca-hoteis'], { queryParams: { codCidade: id } });
    }

    async filterBrands(event) {
        const resultData = await this.hotelService.buscaHoteisAutoComplete(event.query.toLowerCase());
        this.filteredBrands = [];

        resultData.data.paises.forEach(p => {
            this.filteredBrands.push({ tipo: 'paises', data: p });
        });

        resultData.data.estados.forEach(e => {
            this.filteredBrands.push({ tipo: 'estados', data: e });
        });

        resultData.data.cidades.forEach(c => {
            this.filteredBrands.push({ tipo: 'cidades', data: c });
        });

        resultData.data.bairros.forEach(b => {
            this.filteredBrands.push({ tipo: 'bairros', data: b });
        });

        resultData.data.hoteis.forEach(h => {
            this.filteredBrands.push({ tipo: 'hoteis', data: h });
        });
        this.setStorage();
    }

    async selectInAutoComplete() {
        if (this.brand.tipo === 'hoteis') {
            const param = this.brand.data.id + '_' + this.brand.data.slug;
            this.router.navigate(['/hoteis/hotel/', param]);
            this.queryParamData = param;
            this.loadPrimeiroDestino();
            if (this.queryParamData) {
                this.loadDetalheHotel();
            }
        } else if (this.brand.tipo === 'cidades') {
            localStorage.setItem('autocomplete', JSON.stringify(true));
            localStorage.setItem('auto-complete-data', JSON.stringify(this.brand));
            this.router.navigate(['/busca-hoteis'], { queryParams: { codCidade: this.brand.data.id } });
        } else if (this.brand.tipo === 'estados') {
            localStorage.setItem('autocomplete', JSON.stringify(true));
            localStorage.setItem('auto-complete-data', JSON.stringify(this.brand));
            this.router.navigate(['/busca-hoteis'], { queryParams: { codEstado: this.brand.data.id } });
        } else if (this.brand.tipo === 'paises') {
            localStorage.setItem('autocomplete', JSON.stringify(true));
            localStorage.setItem('auto-complete-data', JSON.stringify(this.brand));
            this.router.navigate(['/busca-hoteis'], { queryParams: { codPais: this.brand.data.id } });
        }
        if (this.queryParamData) {
            await this.loadDetalheHotel();
            await this.getPlanos();
        }
    }

    getDetalheAutoComplete(autocomplete) {
        let detalhe = '';
        if (autocomplete.tipo === 'estados') {
            detalhe = autocomplete.data.pais;
        } else if (autocomplete.tipo === 'cidades') {
            detalhe = autocomplete.data.codEstado;
        } else if (autocomplete.tipo === 'bairros') {
            detalhe = autocomplete.data.cidade + ' - ' + autocomplete.data.codEstado;
        } else if (autocomplete.tipo === 'hoteis') {
            detalhe = autocomplete.data.cidade + ' - ' + autocomplete.data.codEstado;
        }
        return detalhe;
    }

    getNomeAutoComplete(autocomplete) {
        let detalhe = '';
        if (autocomplete.tipo === 'estados') {
            detalhe = autocomplete.data.nome + ' (UF)';
        } else {
            detalhe = autocomplete.data.nome;
        }
        return detalhe;
    }

    getQuantidadeHoteis(autocomplete) {
        let quantidade = '';
        if (autocomplete.tipo !== 'hoteis') {
            if (autocomplete.data.quantidade > 1) {
                quantidade = autocomplete.data.quantidade + ' hoteis';
            } else {
                quantidade = autocomplete.data.quantidade + ' hotel';
            }
        }
        return quantidade;
    }

    isPlanosPeriodo(hotel: Hotel) {
        if (hotel) {
            return this.isPlanoPeriodo(hotel.planosPeriodoDuplo) && this.isPlanoPeriodo(hotel.planosPeriodoTriplo);
        }
        return false;
    }

    isPlanoPeriodo(planoPeriodo: any) {
        return !(planoPeriodo === null || planoPeriodo === []);
    }


    obterNomePlano(planoPeriodo: string, tipo: string) {
        return planoPeriodo ? planoPeriodo + ' ' + tipo : 'consulte condições no 0800 610 2200';
    }

    isContratoPeriodo(planoPeriodo: any, tipo: string) {
        let contratoPeriodo = false;

        planoPeriodo.forEach( obj => {
            if ((tipo === 'D' && obj.planoDuplo && obj.planoDuplo.indexOf('Contrato') !== -1) || (tipo === 'T'
                && obj.planoTriplo && obj.planoTriplo.indexOf('Contrato') !== -1)) {
                contratoPeriodo = false;
                return;
            }

            contratoPeriodo = true;
        });
        return contratoPeriodo;
    }

    scroll(el) {
        const yOffset = -150;
        const e = document.getElementById(el);
        if (e) {
            const y = e.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    }

    private handleMobile() {
        this.innerWidth = window.innerWidth;
        if (this.innerWidth < 1026) {
            if (this.innerWidth <= 412) {
                this.panelWidth = '100%';
                this.panelHeight = '200';
            }
            this.isMobile = true;
            return;
        }
        this.isMobile = false;
    }

    onFacaParte() {
        localStorage.setItem('mtl.proposta', JSON.stringify(this.proposta));
        this.router.navigate(['faca-parte']);
    }
    private async getPlanos() {
        this.appComponent.showOverlay();
        let planos: Planos[];
        let plano: Planos;
        const tipoQuarto =  this.getTipoQuarto(this.detalheHotel.tipoQuarto);
        const tipoPlano = (tipoQuarto === 'Triplo') ? this.detalheHotel.tipoPlano + ' ' + tipoQuarto : this.detalheHotel.tipoPlano;
        if (this.detalheHotel.tipoPlano.toUpperCase() !== 'Sem Plano'.toUpperCase()) {
            const result = await this.categoriaPlanoRepository.planos();
            planos = result.data;
            planos = planos.filter(value => value.descricao === tipoPlano);
            plano = planos[0];
            plano.qtdDiarias = plano.qtdDiarias.filter(x => x.quantidadeDiarias === 7);
            plano.descricao = this.categoriaPlanoRepository.cleanDescriptionTriple(plano.descricao).replace(/\s/g, '');
            plano.descricao = plano.descricao.charAt(0).toUpperCase() + plano.descricao.slice(1);
        }
        this.plano = plano;
        this.tipoQuarto = tipoQuarto;
        this.setStorage();
        this.appComponent.hideOverlay();
    }

    setStorage() {
        if (this.plano !== undefined) {
            localStorage.removeItem('mtl.proposta');
            const plano: Planos = this.plano;
            const tipoQuarto: string = this.tipoQuarto;
            const valoresTitulosDetalhado: ValoresTitulosDetalhado = {
                categoriaDescricao: plano.descricao,
                codigoCategoria: plano.codigoCategoria,
                descricao: plano.qtdDiarias[0].descricao,
                qtdTitulos: plano.qtdDiarias.length,
                quantidadeDiarias: plano.qtdDiarias[0].quantidadeDiarias,
                valor: plano.qtdDiarias[0].valor
            };
            const itemPropostaResult: ItemProposta = {
                categoriaTitulo: plano.descricao,
                codigoCategoria: plano.codigoCategoria,
                diarias: plano.qtdDiarias[0].quantidadeDiarias,
                pessoas: (tipoQuarto === 'Triplo') ? 3 : 2,
                quartos: 1,
                valor: plano.qtdDiarias[0].valor,
                valoresTitulosDetalhado: [valoresTitulosDetalhado]
            };
            this.proposta = {
                fidelizacaoCliente: true,
                idConta: '',
                idContato: '',
                idCotacao: '',
                idOportunidade: '',
                cupom: '',
                cupomId: null,
                cupomAceito: false,
                itensProposta: [itemPropostaResult],
                mensagemCupom: '',
                valorAdesao: 'R$ 600,00',
                valorMensalidade: this.categoriaPlanoRepository.monthlyValueString(plano.qtdDiarias[0].descricao),
                valorAdesaoDesconto: 0,
                valorMensalidadeDesconto: 0,
                quartoDuplo: tipoQuarto === 'Triplo' ? 0 : 1,
                quartoTriplo: tipoQuarto === 'Triplo' ? 1 : 0,
            };
            localStorage.setItem('mtl.proposta', JSON.stringify(this.proposta));
        }
    }

    getTipoQuarto(tipoQuarto) {
        let quarto;
        switch (tipoQuarto.length) {
            case 1:
                quarto = tipoQuarto[0];
                break;
            case 2:
                quarto = tipoQuarto[1];
                break;
            default:
                quarto = 'Nenhum';
                break;
        }
        return quarto;
    }

    private setAltTitleHoteisProximos(hotel: Hotel) {
        const data = [];
        hotel.hoteisProximos.forEach(element => {
            element.alt = `Montreal Viagens - ${element.nome}`;
            element.title = element.alt;
            data.push(element);
        });
        hotel.hoteisProximos = data;
        return hotel;
    }

    hasMap(detalheHotel: any) {
        const {latitude = 0, longitude = 0 } = detalheHotel || {};
        return latitude !== 0 && longitude !== 0;
    }
}
